import { render } from "./GiftSendItem.vue?vue&type=template&id=12d53b35&scoped=true"
import script from "./GiftSendItem.vue?vue&type=script&lang=js"
export * from "./GiftSendItem.vue?vue&type=script&lang=js"

import "./GiftSendItem.vue?vue&type=style&index=0&id=12d53b35&scoped=true&lang=css"

import exportComponent from "/home/viewchat/public_html/viewchat-web-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12d53b35"]])

export default __exports__